/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TasksV2SubTypesEnum } from './tasksV2SubTypesEnum';
import { BackupOperationEnum } from './backupOperationEnum';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { TaskResourceType } from './taskResourceType';
import { TasksV2TypesEnum } from './tasksV2TypesEnum';
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';


export interface TaskBackupSpec { 
    task_id?: string;
    task_sub_type?: TasksV2SubTypesEnum;
    task_type?: TasksV2TypesEnum;
    service_type?: ServiceTypeEnum;
    vcds_service_type?: VcdsServiceTypeEnum;
    operation: BackupOperationEnum;
    resource_type?: TaskResourceType;
    /**
     * The start period of the retention/ purge
     */
    start_date?: string;
    /**
     * The end period of the retention/ purge
     */
    end_date?: string;
    /**
     * Execute the operation in dry-run mode. When true, performs validation and query matching but skips actual database modifications.
     */
    dry_run?: boolean;
}
export namespace TaskBackupSpec {
}


